import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../components/common/Loader";

import { RootStoreContext } from "./stores/rootStore";
import { disableBodyScroll } from "body-scroll-lock";

import { IExistingSqliteConn, ISqlite } from "./models/db";

import "./localization/localization";

import GuestLayout from "../layouts/GuestLayout";
import {ResponsiveComponent} from "../components/common/ResponsiveComponent"

import ScreenCodePage from "../components/guest/ScreenCodePage";


const Guest: React.FC<RouteComponentProps> = ({ location }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    getCompany,
    setCompanyLoaded,
    setAppLoaded,
    // token,
    InitNativeApp,
    updateOfflineModeEnabled,
    isOfflineModeEnabled,
    nativeAppLoaded,
    setNativeAppLoaded,
    everythingLoaded,
  } = rootStore.commonStore;
  


  

  useEffect(() => {
    InitNativeApp()
      .then(() => {
        updateOfflineModeEnabled(!navigator.onLine);
        disableBodyScroll(document.body);
      })
      .catch((e) => console.log(e))
      .finally(() => setNativeAppLoaded());
  }, [InitNativeApp, updateOfflineModeEnabled, setNativeAppLoaded]);

  useEffect(() => {
    if (nativeAppLoaded) {
      const urlParams = new URLSearchParams(location.search);
      const companyIdApp = process.env.REACT_APP_FORCE_COMPANYID ?? "";
      const companyIdQuerystring = urlParams.get("companyId") ?? "";
      const companyId = companyIdQuerystring
        ? companyIdQuerystring
        : companyIdApp;
      getCompany(companyId)
        .then()
        .finally(() => setCompanyLoaded());
    }
  }, [getCompany, location.search, setCompanyLoaded, nativeAppLoaded]);

  //tolto token dal array delle dipendenze per evitare chiamate multiple
  useEffect(() => {
    // console.log("LoggedIn : " + isLoggedIn)
   
      setAppLoaded();
    
  }, [ setAppLoaded, isOfflineModeEnabled]);

  if (!everythingLoaded) return <Loader />;

  return (
    <>
    <ResponsiveComponent/>
      <ToastContainer
        position="bottom-right"
        pauseOnFocusLoss={false}
        limit={4}
        />
      
    
        <Switch>
        <Route exact path="/screen" component={ScreenCodePage} />
        <Route exact path="/guestscreen" component={ScreenCodePage} />
          {/* <Route exact path="/guest/:zone" component={GuestLayout} /> */}
        <Route  path="/" component={GuestLayout} />
         
         
       
        </Switch>
      
    </>
  );
};

export default withRouter(observer(Guest));
